import React, { useState, useEffect } from 'react';
import './DrinkPopup.css';

function DrinkPopup({ players, onClose, onDistribute, maxDrinks = 5, multiplier = 1, socket, lobbyCode, currentPhase }) {
  const [selectedPlayer, setSelectedPlayer] = useState('');

  // Auto-select if only one player
  useEffect(() => {
    if (players.length === 1) {
      setSelectedPlayer(players[0].name);
    }
  }, [players]);

  const handlePlayerClick = (playerName) => {
    setSelectedPlayer(playerName);
    // Auto-distribute with fixed amount and multiplier
    const totalSips = maxDrinks * multiplier;
    onDistribute(playerName, totalSips);
    onClose();
  };


  return (
    <div className="drink-popup-overlay">
      <div className="drink-popup">
        <div className="drink-popup-header">
          <h2>🍺 Give Out Drinks</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>

        <div className="drink-popup-content">
          <div className="drink-section">
            <label>Select Player:</label>
            <div className="player-list">
              {players.map((player, idx) => (
                <div
                  key={idx}
                  className={`player-item ${selectedPlayer === player.name ? 'selected' : ''}`}
                  onClick={() => handlePlayerClick(player.name)}
                >
                  <span className="player-name">{player.name}</span>
                  {selectedPlayer === player.name && <span className="checkmark">✓</span>}
                </div>
              ))}
            </div>
          </div>

          <div className="drink-info">
            <p className="drink-amount-display">
              Click a player to give them <strong>{maxDrinks * multiplier}</strong> sip{(maxDrinks * multiplier) > 1 ? 's' : ''}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DrinkPopup;
